import React from 'react';
import styles from './Header.styles.scss';
import OtaLogo from '../../../../../../assets/images/dark_logo.png';
import cn from 'classnames';

import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

const Header = ({ t, onHomeClick, onExitClick }) => {
  const logo = OtaLogo;

  return (
    <div className={cn(styles.header)}>
      <div className={cn(styles.logoAndHome, 'fluid')}>
        <Button link className={cn(styles.logo)} onClick={onHomeClick}>
          <img src={logo} alt="logo" />
        </Button>
        <Divider
          layout="vertical"
          style={{
            minHeight: 'initial',
          }}
        />
        <h2>{t('generate-e-invoice')}</h2>
      </div>
      <div className={cn(styles.innerDiv, 'hstack gap-3 p-3 d-md-flex d-none')}>
        <div className={cn('ms-auto d-flex align-items-center')}>
          <div className={cn('col-4 fluid', styles.nameAndLang)}>
            <Button
              className={cn(styles.exitButton)}
              onClick={onExitClick}
              text
              label={t('exit')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Header);
